import { render, staticRenderFns } from "./itemChild.vue?vue&type=template&id=6c5e1ac3&scoped=true"
import script from "./itemChild.vue?vue&type=script&lang=js"
export * from "./itemChild.vue?vue&type=script&lang=js"
import style0 from "./itemChild.vue?vue&type=style&index=0&id=6c5e1ac3&prod&scoped=true&lang=css"
import style1 from "./itemChild.vue?vue&type=style&index=1&id=6c5e1ac3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5e1ac3",
  null
  
)

export default component.exports